export default __webpack_public_path__ + "static/media/opasek_konfety.2fdf8bc8.jpg";